import styled, { css } from 'styled-components'
import VerifiedBadge from '@/components/verified-badge'
import { fontWeights, fontSizes, breakpoints } from '@/styles'
import formatName from '@/utils/format-name'
import { formatPhone } from '@/utils/format-phone'
import isVerified from '@/utils/is-verified'

const NameText = styled.h1`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.medium};
  line-height: 28px;
  max-width: 85%;
  margin: 0 0 9px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: ${fontSizes.regular};
    line-height: 22px;
  }

  @media print {
    white-space: unset;
  }
`

const ContactText = styled.p`
  font-size: ${fontSizes.regular};
  margin: 0;
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: ${fontSizes.small};
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    max-width: 220px;
  }

  @media screen and (max-width: ${breakpoints.smallPhone}) {
    max-width: 180px;
  }
`

const normalStyle = css`
  display: block;
  > :not(:last-child) {
    &:after {
      content: '';
    }
  }
  > * {
    padding-right: 15px;
  }
`

const BaseWrapper = styled.div`
  max-width: 450px;
  overflow: hidden;
`

const BreakLinesWrapper = styled(BaseWrapper)`
  ${normalStyle}
`

const WrapLinesWrapper = styled(BaseWrapper)`
  display: flex;
  flex-wrap: wrap;
  > :not(:last-child) {
    &:after {
      content: ' | ';
      font-weight: ${fontWeights.medium};
      font-size: ${fontSizes.regular};
      white-space: pre;
    }
  }
  > :last-child {
    padding-right: 15px;
  }
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    ${normalStyle}
  }
`

const formatFullName = data => {
  const end =
    data.preferred_name && data.preferred_name !== data.first_name
      ? ` (${data.preferred_name})`
      : ''
  return `${data.first_name} ${data.last_name}${end}`
}

const ContactInfo = ({ data = {}, showFullName = true, lineWrap = true, hideContact }) => {
  const company = data?.company_info
  const hasCompany = data?.account_type === 'business' && !!company?.name
  const InfoWrapper = lineWrap || !data.phone ? BreakLinesWrapper : WrapLinesWrapper
  const loading = !data?.id

  return (
    <>
      {loading ? (
        <>
          <NameText>&nbsp;</NameText>
          <InfoWrapper>
            <ContactText>&nbsp;</ContactText>
          </InfoWrapper>
        </>
      ) : (
        <>
          <NameText>
            {!showFullName ? formatName(data) : formatFullName(data)}
            <VerifiedBadge
              type="id"
              width={30}
              height={26}
              left={5}
              bottom={-4}
              verified={isVerified(data, company)}
            />
          </NameText>
          {!hideContact && (
            <InfoWrapper>
              {!hasCompany && (
                <ContactText>
                  {formatPhone(data.phone_number, data.phone_country_code_alpha)}
                </ContactText>
              )}
              <ContactText>{hasCompany ? company?.name : data.username}</ContactText>
            </InfoWrapper>
          )}
        </>
      )}
    </>
  )
}

export default ContactInfo
